export const idLengthRegex = /^[a-zA-Z0-9]{5,10}$/;
export const passwordLengthRegex = /^.{8,16}$/;
export const passwordConsecutiveRegex = /^(?!.*(.)\1{3}).*$/;
export const passwordCharactersRegex = /^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)(?=.*[@$!%*?&])[A-Za-z\d@$!%*?&]+$/;

export const passwordRegex = /^(?=.*[A-Z])(?=.*[a-z])(?=.*\d)(?=.*[@$!%*?&])(?=.*(.)\1{0,2})(?!.*(.)\2{3,}).{8,16}$/;
